import { render } from "./OrdersFlowCard.vue?vue&type=template&id=3b2363c6&scoped=true"
import script from "./OrdersFlowCard.vue?vue&type=script&lang=js"
export * from "./OrdersFlowCard.vue?vue&type=script&lang=js"

import "./OrdersFlowCard.vue?vue&type=style&index=0&id=3b2363c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2363c6"]])

export default __exports__